import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

function AuctionLaneSelect({ value, onChange, username, fullWidth = true, sx = {} }) {
  const [lanes, setLanes] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newLaneName, setNewLaneName] = useState('');

  useEffect(() => {
    if (username) {
      fetchAuctionLanes();
    }
  }, [username]);

  const fetchAuctionLanes = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auction-lanes?username=${username}`
      );
      const data = await response.json();
      if (response.ok) {
        setLanes(data.lanes || []);
      }
    } catch (error) {
      console.error('Error fetching auction lanes:', error);
    }
  };

  const handleAddNewLane = async () => {
    if (!newLaneName.trim()) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auction-lanes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          lane_name: newLaneName.trim(),
        }),
      });

      if (response.ok) {
        await fetchAuctionLanes();
        onChange({ target: { name: 'auction_lane', value: newLaneName.trim() } });
        setNewLaneName('');
        setDialogOpen(false);
      }
    } catch (error) {
      console.error('Error adding auction lane:', error);
    }
  };

  return (
    <>
      <FormControl fullWidth={fullWidth} sx={sx}>
        <InputLabel>Auction Lane</InputLabel>
        <Select
          name="auction_lane"
          value={value || ''}
          onChange={onChange}
          label="Auction Lane"
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {lanes.map((lane) => (
            <MenuItem key={lane} value={lane}>
              {lane}
            </MenuItem>
          ))}
          <MenuItem
            onClick={(e) => {
              e.preventDefault();
              setDialogOpen(true);
            }}
            sx={{
              color: 'primary.main',
              fontWeight: 'bold',
              borderTop: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <AddIcon fontSize="small" />
              Add New Lane
            </Box>
          </MenuItem>
        </Select>
      </FormControl>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add New Auction Lane</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Lane Name"
            fullWidth
            variant="outlined"
            value={newLaneName}
            onChange={(e) => setNewLaneName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleAddNewLane();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleAddNewLane} variant="contained">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AuctionLaneSelect; 